const axios = require('axios');
const {showSnack} = require("@/core/codeFunctions");
let serverAddress = null;
let token;
let userId;
let siteId;
// let window = null;

function setWindow(val) {
    // window = val
}

const liveApi = false;


function redirectURL() {
    window.location.href = liveApi ? `https://trl.tracklogix.app` : `${window.location.protocol}//${window.location.hostname}:${window.location.port}`
}

// Local Functions
setServerAddress();
function setServerAddress() {
    serverAddress = liveApi ? `https://trl.tracklogix.app` : `https://${window.location.hostname}`
}

// Public Functions
function newReq(method, url, data = null, includeCredentials = true, fullResponse = false) {
    return new Promise((resolve, reject) => {
        let config = {method: method.toLowerCase(), url: `${serverAddress}/${url}`,}
        if (method.toLowerCase() !== 'get' && data !== null) {config.data = data}

        if (includeCredentials) {config.headers = {"tauth": `${token}-${userId}`}}

        if (includeCredentials && siteId) {config.headers.tsite = siteId}
        axios(config)
            .then(response => {
                if (response.status === 200) {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        resolve(fullResponse ? response: response.data)
                    }
                } else {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        reject(fullResponse ? response: response.data)
                    }
                }
            })
            .catch(e => {
                if (e && e.response && e.response.status && e.response.status === 401)
                    return location.reload();
                if (e.response)
                    reject(e.response.data); // => the response payload
                else reject(e)
            })
    })
}
function newReqUpload(method, url, file = null, formFieldName = null, includeCredentials = true, onProgressCB = null, fullResponse = false) {
    return new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append(formFieldName, file);
        let config = {method: method.toLowerCase(), url: `${serverAddress}/${url}`, data: formData}
        if (onProgressCB != null)
            config.onUploadProgress = onProgressCB
        if (includeCredentials) {config.headers = {"tauth": `${token}-${userId}`}}
        if (includeCredentials && siteId) {config.headers.tsite = siteId}
        axios(config)
            .then(response => {
                if (response.status === 200) {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        resolve(fullResponse ? response: response.data)
                    }
                } else {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        reject(fullResponse ? response: response.data)
                    }
                }
            })
            .catch(e => {
                reject(e)
            })
    })
}
function newReqDownloadFile(method, url, data = null, filename = null, includeCredentials = true, fullResponse = false, onProgressCB = null, rawResponse = false) {
    return new Promise((resolve, reject) => {
        let config = {method: method.toLowerCase(), url: `${serverAddress}/${url}`, responseType: 'blob'}
        if (onProgressCB != null)
            config.onDownloadProgress = onProgressCB
        if (method.toLowerCase() !== 'get' && data !== null) {config.data = data}
        if (includeCredentials) {config.headers = {"tauth": `${token}-${userId}`}}
        if (includeCredentials && siteId) {config.headers.tsite = siteId}
        axios(config)
            .then(response => {
                if (response.status === 200) {
                    if (rawResponse) {
                        resolve(response)
                    } else {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.target = "_blank"
                        if (filename !== null)
                            link.setAttribute('download', filename); //or any other extension
                        document.body.appendChild(link);
                        link.click();
                        resolve(true)
                    }
                } else {
                    try {
                        response.data = JSON.parse(response.data)
                    } finally {
                        reject(fullResponse ? response: response.data)
                    }
                }
            })
            .catch(e => {
                reject(e)
            })
    })
}
function initialize(tokenObj) {
    token = tokenObj.token;
    userId = tokenObj.userId;
    getFeedServer();

    // Refresh @ 75%

    refreshToken(Math.floor((tokenObj.expires / 100) * 75));
}

function initializeSite(site) {
    siteId = site;
    const {switchSite} = require("@/core/realtimeSync");
    switchSite(site)
}

function refreshToken(timeout = 2700000, retry = false) {
    setTimeout(async() => {
        try {
            const newToken = await newReq('GET', `refreshToken`)
            token = newToken
            refreshToken(timeout);
        } catch (e) {
            console.log(e)
            refreshToken(timeout, true)
        }
    }, retry ? 1000 : timeout)
}

function getFeedServer() {
    newReq('GET', `realtimeServer`)
        .then(socketServer => {
            const {initSocket} = require("@/core/realtimeSync");
            initSocket(`https://${socketServer.server}`, getToken)
        })
        .catch(e => {
            console.log(e)
            setTimeout(() => {
                getFeedServer();
            }, 1000)
        })
}

function getToken() {
    return {token: `${token}-${userId}`}
}



module.exports = {
    newReq,
    newReqUpload,
    newReqDownloadFile,
    initializeRequestAuth: initialize,
    redirectURL,
    token: getToken,
    getServerAddress: () => {
        return serverAddress
    },
    initializeSite,
    setWindow
}
